import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button, EmptyState } from '../ui';

// Last-resort UI guard: without this, an uncaught render error anywhere in the
// tree unmounts the whole app and leaves partners staring at a blank white
// page with no way to recover short of a manual reload.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error', {
      action: 'ui.render_error',
      outcome: 'failure',
      message: error?.message,
      componentStack: info?.componentStack,
    });
  }

  handleReset = () => {
    this.setState({ error: null });
    window.location.assign('/');
  };

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (!error) return children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-50 px-4">
        <div className="max-w-md w-full bg-white border border-ink-200 rounded-xl shadow-card">
          <EmptyState
            icon={AlertTriangle}
            title="Something went wrong"
            description="An unexpected error occurred. You can try returning to the dashboard, and our team has been notified."
            action={<Button variant="primary" onClick={this.handleReset}>Back to dashboard</Button>}
          />
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
